import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Music2, Mail, Sparkles } from 'lucide-react';
import { Logo } from './Logo';
const primaryLinks = [{
  name: 'Meet Milangela',
  path: '/meet-milangela'
}, {
  name: 'Start Your Journey',
  path: '/start-your-journey'
}, {
  name: "Let's Connect",
  path: '/lets-connect'
}];
const gardenLinks = [{
  name: 'Journal',
  path: '/journal'
}, {
  name: 'Podcasts',
  path: '/podcasts'
}, {
  name: 'Guided Meditations',
  path: '/guided-meditations'
}];
export function Footer() {
  return <footer className="relative overflow-hidden bg-charcoal text-cream-100" data-id="element-299" data-mp="3ldu34pweqfur">
      <div aria-hidden="true" className="pointer-events-none absolute -left-40 top-1/4 h-[36rem] w-[36rem] rounded-full bg-rose/[0.04] blur-[120px]" data-id="element-300" data-mp="3qcdux6xomlv1" />
      <div aria-hidden="true" className="pointer-events-none absolute -right-40 bottom-0 h-[36rem] w-[36rem] rounded-full bg-sage/[0.04] blur-[120px]" data-id="element-301" data-mp="2eyt6sj3gzvnn" />

      <div className="relative mx-auto max-w-5xl px-6 pb-10 pt-16 text-center md:pt-20" data-id="element-302" data-mp="3lbdc0r0ka5kr">
        <div className="mb-5 flex items-center justify-center gap-3 text-rose" data-id="element-303" data-mp="3gcjvsqtw40gw">
          <span className="block h-px w-10 bg-cream-100/20" data-id="element-304" data-mp="3v919hopjxr6m" />
          <Sparkles size={14} strokeWidth={1.25} aria-hidden="true" data-id="element-305" data-mp="3q8dj9595dedg" />
          <span className="block h-px w-10 bg-cream-100/20" data-id="element-306" data-mp="830ibgbgg0zf" />
        </div>

        <p className="mx-auto mb-10 max-w-xl font-serif text-xl italic leading-relaxed text-cream md:text-2xl" data-id="element-307" data-mp="80xjc6sbqxik">
          May you walk gently, listen deeply, and return to your own quiet
          center.
        </p>

        <nav aria-label="Footer navigation" className="mb-10" data-id="element-308" data-mp="ctqogvrpg7v6">
          <div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-4" data-id="element-309" data-mp="cu8sieklzqdn">
            {primaryLinks.slice(0, 1).map(link => <Link key={link.path} to={link.path} className="text-xs font-medium tracking-[0.16em] text-cream-100/85 uppercase transition-colors hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose focus:ring-offset-2 focus:ring-offset-charcoal" data-id="element-310" data-mp="ms6gr22gxn69">
                {link.name}
              </Link>)}

            {gardenLinks.map(link => <Link key={link.path} to={link.path} className="text-xs font-medium tracking-[0.16em] text-cream-100/85 uppercase transition-colors hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose focus:ring-offset-2 focus:ring-offset-charcoal" data-id="element-311" data-mp="18l2f4s6dqbyy">
                {link.name}
              </Link>)}

            {primaryLinks.slice(1).map(link => <Link key={link.path} to={link.path} className="text-xs font-medium tracking-[0.16em] text-cream-100/85 uppercase transition-colors hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose focus:ring-offset-2 focus:ring-offset-charcoal" data-id="element-312" data-mp="1rgsiaiq1teef">
                {link.name}
              </Link>)}
          </div>
        </nav>

        <a href="mailto:branka@milangelassoulgarden.com" className="group mb-7 inline-flex items-center gap-2 text-sm text-rose transition-colors hover:text-rose-100 focus:outline-none focus:ring-2 focus:ring-rose focus:ring-offset-2 focus:ring-offset-charcoal" data-id="element-313" data-mp="25mkhizvt6khz">
          <span className="flex h-7 w-7 items-center justify-center rounded-full border border-rose/40 transition-colors group-hover:border-rose" data-id="element-314" data-mp="2tbn6kssrvfmi">
            <Mail size={13} strokeWidth={1.5} aria-hidden="true" data-id="element-315" data-mp="2kc8g3tclv520" />
          </span>
          <span className="font-serif text-base italic" data-id="element-316" data-mp="2feq6s1uoenth">
            branka@milangelassoulgarden.com
          </span>
        </a>

        <div className="mb-9 flex items-center justify-center gap-5" data-id="element-317" data-mp="18yxlh32nd452">
          <a href="#" aria-label="Facebook" className="text-cream-100/80 transition-all hover:-translate-y-0.5 hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose" data-id="element-318" data-mp="13yi7qaegdumk">
            <Facebook size={19} strokeWidth={1.5} data-id="element-319" data-mp="2wn98c31bap0b" />
          </a>
          <a href="#" aria-label="Instagram" className="text-cream-100/80 transition-all hover:-translate-y-0.5 hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose" data-id="element-320" data-mp="2ivkyy7ig6en1">
            <Instagram size={19} strokeWidth={1.5} data-id="element-321" data-mp="3bkrt6uavci2h" />
          </a>
          <a href="#" aria-label="YouTube" className="text-cream-100/80 transition-all hover:-translate-y-0.5 hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose" data-id="element-322" data-mp="3fl1zy96hjcie">
            <Youtube size={19} strokeWidth={1.5} data-id="element-323" data-mp="36jkoj440vz01" />
          </a>
          <a href="#" aria-label="Spotify" className="text-cream-100/80 transition-all hover:-translate-y-0.5 hover:text-cream focus:outline-none focus:ring-2 focus:ring-rose" data-id="element-324" data-mp="1q6dpwelda6nj">
            <Music2 size={19} strokeWidth={1.5} data-id="element-325" data-mp="1nl6aw2fqltp9" />
          </a>
        </div>

        <div className="mb-8 border-t border-cream-100/20 pt-5 text-xs text-cream-100/65" data-id="element-326" data-mp="1in4r1fahlqcq">
          <p data-id="element-327" data-mp="1wmnl546gr161">
            © {new Date().getFullYear()} Milangela's Soul Garden — made with
            care.
          </p>
        </div>

        <Link to="/" aria-label="Milangela's Soul Garden home" className="inline-flex focus:outline-none focus:ring-2 focus:ring-rose focus:ring-offset-2 focus:ring-offset-charcoal" data-id="element-328" data-mp="1rom3mnoor9wo">
          <Logo variant="white" className="h-9 w-auto" data-id="element-329" data-mp="zxy5lkib6kn8" />
        </Link>
      </div>
    </footer>;
}